"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M38.143 36a7.857 7.857 0 0 0 0-15.714 7.94 7.94 0 0 0-.887.05 9.954 9.954 0 1 0-19.46-3.954A8.386 8.386 0 0 0 7.522 26.64 4.715 4.715 0 1 0 6.714 36z" })
);

